<script>
	import TabBarItem from './TabBarItem.svelte';

	export let scrolled = false;
	export let scrollDirection = 'up';
</script>

<nav class="tab-bar scroll-direction-{scrollDirection}" class:scrolled>
	<slot {TabBarItem} />
</nav>

<style>.tab-bar{background:hsla(var(--hsl-white));box-shadow:var(--shadow-sm);display:grid;grid-auto-flow:column;height:var(--ui-tab-bar-height);transition:all var(--time-xs) ease-out;z-index:1}.scrolled.scroll-direction-down{translate:0 100%}</style>
